export enum Permission {
  Unspecified = 0,
  Allowed = 1,
  Denied = 2,
  Mixed = 3
}

// larger reasons take precedence
export enum PermissionReason {
  Unspecified = 0,
  ImplicitDeny = 1,
  DerivedWriteAllow = 2,
  GroupAllow = 3,
  GroupDeny = 4,
  UserAllow = 5,
  UserDeny = 6,
  DerivedAllow = 7,
  UserLicensingDeny = 8,
  GuestAllow = 9,
  UserAuthorizableOwnerAllow = 10,
  GroupProjectLeaderAllow = 11,
  UserProjectLeaderAllow = 12,
  UserProjectOwnerAllow = 13,
  UserAdminAllow = 14,
  Mixed = 15,
}

export interface IPermission {
  permission: Permission;
  reason: PermissionReason;
}
